import { render, staticRenderFns } from "./Datetime.vue?vue&type=template&id=38fed31a&scoped=true"
import script from "./Datetime.vue?vue&type=script&lang=js"
export * from "./Datetime.vue?vue&type=script&lang=js"
import style0 from "./Datetime.vue?vue&type=style&index=0&id=38fed31a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fed31a",
  null
  
)

export default component.exports